<template>
    <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
        <FormInput :label="dniLabel" name="dni" rules="required" id="dni" v-model="abonado.dni" />
        <FormInput v-if="teatro.hash !== '2IcJsvmDMf3LM9rJREmH'" class="mb-3 mb-lg-4" :label="nAbonadoLabel" name="n_abonado" id="n_abonado" rules="required" v-model="abonado.n_abonado" />
        <button type="submit" :disabled="abonadoSeleccionado" class="button large-button effect-button"><span>{{ $t('partido.buscar') }}</span></button>
    </ValidationObserver>
</template>

<script>
    import { TEATROS_UCAM_EVENTOS, TEATRO_HASH_RIBADESELLA } from '@/constants/teatros';

    export default {
        props: ['abonado', 'abonadoSeleccionado'],
        data() {
            return {
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            },
            terminar() {
                this.$emit('terminado');
            }
        },
        computed: {
            teatro(){
                return this.$store.getters.getTeatro;
            },
            // Etiqueta del campo de identificación del abonado. El payload que se
            // envía a la API no cambia: el campo sigue siendo `dni`.
            dniLabel(){
                if(this.teatro.hash === 'ktEQfwmffBlx37Ws043A') {
                    return this.$t('formularios.apellidos');
                }

                if(this.teatro.hash === TEATRO_HASH_RIBADESELLA) {
                    return this.$t('formularios.nombre_apellidos');
                }

                if(this.teatro.hash === 'XSb8uxOmqRUI9fMC3Kos') {
                    return 'Usuario';
                }

                return this.$t('formularios.dni');
            },
            nAbonadoLabel(){
                if(TEATROS_UCAM_EVENTOS.includes(this.teatro.hash)) {
                    return this.$t('perfil.ano_graduacion', {abonado: this.teatro.texto_abonado});
                }

                if(this.teatro.hash === 'XSb8uxOmqRUI9fMC3Kos') {
                    return 'PIN';
                }

                return this.$t('formularios.n_abonado', {abonado: this.teatro.texto_abonado});
            },
        }
    }
</script>
